import { createContext, useContext, ReactNode } from "react";
import { useOrgTrades } from "@/hooks/useOrgTrades";

type TradeContextValue = ReturnType<typeof useOrgTrades>;

const TradeContext = createContext<TradeContextValue | null>(null);

export function TradeProvider({ children }: { children: ReactNode }) {
  const value = useOrgTrades();
  return <TradeContext.Provider value={value}>{children}</TradeContext.Provider>;
}

export function useTrade(): TradeContextValue {
  const ctx = useContext(TradeContext);
  if (!ctx) {
    throw new Error("useTrade must be used within a <TradeProvider>");
  }
  return ctx;
}
